/* ==========================================================================
   Candela Cart — Live count updates + mobile checkout bar behavior
   ========================================================================== */

(function () {
  var isMobile = function () {
    return window.matchMedia('(max-width: 989px)').matches;
  };

  /* --- Update all .candela-nav__cart-count elements --- */
  function updateCartCount(count) {
    document.querySelectorAll('.candela-nav__cart-count').forEach(function (el) {
      el.textContent = count;
    });
  }

  /* --- Show/hide mobile checkout bar --- */
  function updateCartBar(count) {
    var bar = document.getElementById('CandelaCartBar');
    if (!bar) return;
    var visible = count > 0;
    bar.classList.toggle('is-visible', visible);
    document.documentElement.style.setProperty(
      '--candela-cart-bar-h',
      visible ? bar.offsetHeight + 'px' : '0px'
    );
  }

  /* --- Fetch fresh cart count from API --- */
  var fetchPending = false;

  function fetchCartCount() {
    if (fetchPending) return;
    fetchPending = true;

    var controller = new AbortController();
    var timeoutId = setTimeout(function () { controller.abort(); }, 8000);

    fetch('/cart.js', { signal: controller.signal })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        updateCartBar(cart.item_count);
      })
      .catch(function () {})
      .finally(function () {
        fetchPending = false;
        clearTimeout(timeoutId);
      });
  }

  /* --- Subscribe to Dawn's cartUpdate pub/sub event --- */
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      var cartData = event.cartData;
      if (cartData && typeof cartData.item_count !== 'undefined') {
        updateCartCount(cartData.item_count);
        updateCartBar(cartData.item_count);
      } else {
        fetchCartCount();
      }
    });
  }

  /* --- Override cart-drawer open behavior on mobile ---
     On mobile: don't auto-open the drawer when adding to cart.
     Instead, just show the checkout bar. */
  function patchCartDrawer() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    drawer.renderContents = function (parsedState) {
      /* Update the drawer inner contents using Dawn's own section rendering */
      var innerEl = this.querySelector('.drawer__inner');
      if (innerEl && innerEl.classList.contains('is-empty')) {
        innerEl.classList.remove('is-empty');
      }
      this.productId = parsedState.id;

      /* Let Dawn's getSectionsToRender handle the DOM update via its own method */
      this.getSectionsToRender().forEach(function (section) {
        var targetEl = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);
        if (!targetEl) return;

        var parsed = new DOMParser().parseFromString(
          parsedState.sections[section.id],
          'text/html'
        );
        var sourceEl = parsed.querySelector(section.selector || '.shopify-section');
        if (!sourceEl) return;

        /* Replace children safely */
        while (targetEl.firstChild) {
          targetEl.removeChild(targetEl.firstChild);
        }
        while (sourceEl.firstChild) {
          targetEl.appendChild(sourceEl.firstChild);
        }
      });

      var overlay = this.querySelector('#CartDrawer-Overlay');
      if (overlay) overlay.addEventListener('click', this.close.bind(this));

      /* Mobile: show checkout bar, don't open drawer */
      if (isMobile()) {
        fetchCartCount();
        return;
      }

      /* Desktop: open drawer as normal */
      this.open();
    };
  }

  /* Safety net: Dawn catches its own exceptions during a cart update and then never
     publishes cartUpdate, which would leave the bar and the count stale. Re-sync
     shortly after any cart mutation control is used. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    if (!e.target.closest('cart-remove-button, .quantity__button')) return;
    setTimeout(fetchCartCount, 900);
    setTimeout(fetchCartCount, 2200);
  });

  /* Set initial cart bar height variable */
  function initCartBarHeight() {
    var bar = document.getElementById('CandelaCartBar');
    if (bar && bar.classList.contains('is-visible')) {
      document.documentElement.style.setProperty(
        '--candela-cart-bar-h', bar.offsetHeight + 'px'
      );
    }
  }

  /* Patch on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      patchCartDrawer();
      initCartBarHeight();
    });
  } else {
    patchCartDrawer();
    initCartBarHeight();
  }
})();
